import { render, staticRenderFns } from "./deptManagerPop.vue?vue&type=template&id=4c7b4ff2"
import script from "./deptManagerPop.vue?vue&type=script&lang=js"
export * from "./deptManagerPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7b4ff2')) {
      api.createRecord('4c7b4ff2', component.options)
    } else {
      api.reload('4c7b4ff2', component.options)
    }
    module.hot.accept("./deptManagerPop.vue?vue&type=template&id=4c7b4ff2", function () {
      api.rerender('4c7b4ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/hrm/deptManagerPop.vue"
export default component.exports